const adminTransactionTypes = require('./admin-transaction-types').enum;

const permissions = {
	adminsList: 'admins_list',
	adminsCreate: 'admins_create',
	adminsDelete: 'admins_delete',
	adminsSetGlobalPermissions: 'admins_set_global_permissions',

	analyticsView: 'analytics_view',
	promoReportView: 'promo_report_view',
	analyticsViewExtendedStat: 'analytics_view_extended_stat',
	changeConversionStatuses: 'change_conversion_statuses',
	analyticsViewConversionsProfit: 'analytics_view_conversions_profit',

	autotrashView: 'autotrash_view',
	autotrashResend: 'autotrash_resend',

	affiliatesList: 'affiliates_list',
	affiliatesListDownload: 'affiliates_list_download',
	affiliateIdsList: 'affiliates_ids_list',
	affiliatesUpdate: 'affiliates_update',
	affiliatesUpdateFeatureFlags: 'affiliates_update_feature_flags',
	loginWithAffiliate: 'affiliates_login',
	registerAffiliate: 'register_affiliate',
	transferPoints: 'transfer_points',
	addLeadSource: 'add_lead_source',
	topAffiliatesViewAll: 'top_affiliates_view_all',
	topCountriesViewAll: 'top_countries_view_all',
	topCountriesViewAllProfits: 'top_countries_view_profits',
	canCopyTotalRow: 'can_copy_total_row',

	transferMoneyBetweenAffiliates: adminTransactionTypes.transfer_money_between_affiliates,
	currencyExchange: adminTransactionTypes.currency_exchange,
	transferPrizeMoney: adminTransactionTypes.transfer_prize_money,
	transferHiddenMoney: adminTransactionTypes.transfer_hidden_money,
	transferAdjustmentMoney: adminTransactionTypes.transfer_adjustment_money,

	transferBalanceAndAccumulatedPoints: 'transfer_balance_and_accumulated_points',

	chainsView: 'chains_view',
	chainsCreate: 'chains_create',
	chainsUpdate: 'chains_update',

	goodsView: 'goods_view',
	goodsCreate: 'goods_create',
	goodsUpdate: 'goods_update',
	goodsDelete: 'goods_delete',

	achievementsView: 'achievements_view',
	achievementsUpdate: 'achievements_update',
	missionsView: 'missions_view',
	missionsUpdate: 'missions_update',

	payoutRequestsViewPersonal: 'payout_requests_personal_view',
	payoutRequestsViewAll: 'payout_requests_view_all',
	payoutRequestsViewMatrixAndHistory: 'payout_requests_view_matrix_and_history',
	payoutRequestsReview: 'payout_requests_review',
	payoutRequestsManagerRole: 'payout_requests_manager_role',
	payoutRequestsConfirm: 'payout_requests_confirm',

	bmAccountsView: 'bm_accounts_view',
	bmAccountsUpdate: 'bm_accounts_update',

	contestView: 'contest_view',
	contestEdit: 'contest_edit',

	payoutSystemsList: 'payout_systems_list',
	payoutSystemsCreate: 'payout_systems_create',
	payoutSystemsUpdate: 'payout_systems_update',
	payoutSystemsDelete: 'payout_systems_delete',
	payoutSystemsGetBalance: 'payout_systems_get_balance',
	payoutSystemsChangeDisplayPriority: 'payout_systems_change_display_priority',

	payoutsList: 'payouts_list',
	payoutsApprove: 'payouts_approve',
	payoutsConfirm: 'payouts_confirm',
	payoutsCreate: 'payouts_create',
	payoutsChangeAutoConfirmSettings: 'payouts_change_auto_confirm_settings',
	payoutsChangeUrgency: 'payouts_change_urgency',

	transactionsCreate: 'transactions_create',

	landingsSnippetsList: 'landings_snippets_list',
	landingsSnippetsUpdate: 'landings_snippets_update',
	landingsSnippetsDelete: 'landings_snippets_delete',

	campaignDomainsList: 'campaign_domains_list',
	campaignDomainsCreate: 'campaign_domains_create',
	campaignDomainsDelete: 'campaign_domains_delete',

	threadsList: 'threads_list',
	threadsCreate: 'threads_create',
	threadsAnswer: 'threads_answer',
	threadsClose: 'threads_close',
	threadsGiftOrderClose: 'threads_gift_order_close',
	threadsListExcludePersonal: 'threads_list_exclude_personal',
	threadsListOnlyPersonal: 'threads_list_only_personal',

	offersList: 'offers_list',
	offersListRemoved: 'offers_list_removed',
	offersListExport: 'offers_list_export',
	offersCreate: 'offers_create',
	offersGrant: 'offers_grant',
	topOffersViewAll: 'top_offers_view_all',
	offersChangeCap: 'offers_change_cap',

	newsList: 'news_list',
	newsCreate: 'news_create',
	newsDelete: 'news_delete',

	discountsList: 'discounts_list',
	discountsCreate: 'discounts_create',
	discountsDelete: 'discounts_delete',

	viewMarketingReports: 'view_marketing_reports',

	managersAffiliatesActivity: 'managers_affiliates_activity',
	affiliatesActivityList: 'affiliates_activity_list',
	registrationAnalytics: 'registration_analytics',
	alertsAnalytics: 'alerts_analytics',
	marketingFunnel: 'marketing_funnel',
	productCap: 'product_cap',
	priorities: 'priorities',
	weeklyReport: 'weekly_report',
	quidsReport: 'quids_report',

	mailingsList: 'mailings_list',
	mailingsCreate: 'mailings_create',
	mailingsDelete: 'mailings_delete',

	definedReferersList: 'defined_referers_list',
	definedReferersUpdate: 'defined_referers_update',

	extThreadsList: 'ext_threads_list',
	extThreadsAnswer: 'ext_threads_answer',
	extThreadsClose: 'ext_threads_close',

	campaignsList: 'campaigns_list',
	campaignsEdit: 'campaigns_edit',

	pollsList: 'polls_list',
	pollsCreate: 'polls_create',
	pollsDelete: 'polls_delete',

	wm: 'wm',

	advRequestList: 'adv_request_list',

	affiliatesRedeemList: 'affiliates_redeem_list',

	conversionsManualApprove: 'conversions_manual_approve',
	conversionsPastManualApprove: 'conversions_past_manual_approve',
	manualApproveRequests: 'manual_approve_requests',
	manualApproveRequestsConfirm: 'manual_approve_requests_confirm',
	conversionsApproveDaily: 'conversions_approve_daily',
	guarantRegisterView: 'guarant_register_view',
	garantForecastView: 'garant_forecast_view',
	guarantRegisterConfirmProlong: 'guarant_register_confirm_prolong',
	garantApproveRequestsView: 'garant_approve_requests_view',
	garantApproveRequestsApprove: 'garant_approve_requests_approve',

	landingNewsList: 'landing_news_list',
	landingNewsCreate: 'landing_news_create',

	finReportsView: 'fin_reports_view',
	landingReportsView: 'landing_reports_view',
	manualAdjustmentsView: 'manual_adjustments_view',

	affiliateReportsView: 'affiliate_reports_view',
	affiliateMonthlyReportView: 'affiliate_monthly_report_view',

	payoutLogView: 'payout_log_view',

	sessionsDelete: 'sessions_delete',

	exchangeRatesList: 'exchange_rates_list',
	exchangeRatesUpdate: 'exchange_rates_update',

	ranksPointsReport: 'ranks_points_report_view',

	banners: 'banners',

	popups: 'popups',

	blog: 'blog',

	cplRulesList: 'cplRulesList',
	cplRulesEdit: 'cplRulesEdit',

	approvedRejectPayoutsList: 'approved_rejected_payouts_view',
	approvedRejectPayoutsEdit: 'approved_rejected_payouts_update',

	geoPayoutRatesList: 'geo_payout_rates_view',
	geoPayoutRatesEdit: 'geo_payout_rates_edit',

	totalDebtView: 'total_debt_view',

	trafficAccountingView: 'traffic_accounting_view',
	affiliateManagersProductivityListAll: 'affiliate_managers_productivity_list_all',
	affiliateManagersProductivityShowMe: 'affiliate_managers_productivity_show_me',

	affiliateCrmEditConfig: 'affiliate_crm_edit_config',
	affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
	affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
};

const locale = {
	ru: {
		adminsList: 'просматривать админов',
		adminsCreate: 'создавать админа',
		adminsDelete: 'удалять админа',
		adminsSetGlobalPermissions: 'устанавливать глобальные права',

		analyticsView: 'просматривать аналитику',
		analyticsViewExtendedStat: 'просматривать расширеную аналитику',
		changeConversionStatuses: 'изменять статусы лидов',
		analyticsViewConversionsProfit: 'просматривать маржу по конверсиям',

		autotrashView: 'просматривать автотреш',
		autotrashResend: 'переотправлять автотреш',

		bmAccountsView: 'просматривать БМ аккаунты',
		bmAccountsUpdate: 'апдейтить БМ аккаунты',

		contestView: 'Просматривать конкурсы',
		contestEdit: 'Редактировать конкурсы',

		affiliatesList: 'просматривать партнеров',
		affiliatesListDownload: 'скачивать список партнеров',
		affiliateIdsList: 'просматривать id вебов',
		affiliatesUpdate: 'обновлять партнера',
		affiliatesUpdateFeatureFlags: 'обновлять feature_flags',
		loginWithAffiliate: 'заходить под партнером',
		transferPoints: 'начислять поинты',
		addLeadSource: 'добавлять источник лидов',
		topAffiliatesViewAll: 'просмотре всех топ вебов',
		topCountriesViewAll: 'просмотр всех стран',
		topCountriesViewAllProfits: 'просмотр всех профитов',
		canCopyTotalRow: 'можно копировать тотал строку',

		transferMoneyBetweenAffiliates: 'перевод дененг между вебами',
		currencyExchange: 'обмен валют у веба',
		transferPrizeMoney: 'начисления за подарки',
		transferHiddenMoney: 'начисления списаных денег',
		transferAdjustmentMoney: 'ручные корректировки начислений',

		transferBalanceAndAccumulatedPoints: 'перенос баланса и накопленных поинтов',

		goodsView: 'просматривать товары',
		goodsCreate: 'создавать товары',
		goodsUpdate: 'обновлять товары',
		goodsDelete: 'удалять товары',

		achievementsView: 'achievements view',
		achievementsUpdate: 'achievements update',
		missionsView: 'missions view',
		missionsUpdate: 'missions update',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		chainsView: 'просматривать связки',
		chainsCreate: 'создавать связки',
		chainsUpdate: 'редактировать связки',

		payoutSystemsList: 'просматривать системы выплат',
		payoutSystemsCreate: 'создавать системы выплат',
		payoutSystemsUpdate: 'обновлять системы выплат',
		payoutSystemsDelete: 'удалять системы выплат',
		payoutSystemsGetBalance: 'смотреть балансы систем выплат',

		transactionsCreate: 'переводить средства партнерам на баланс',

		payoutsList: 'просматривать выплаты',
		payoutsApprove: 'подтверждать выплаты',
		payoutsConfirm: 'оплачивать выплаты',
		payoutsCreate: 'создавать выплаты партнерам',
		payoutsChangeAutoConfirmSettings: 'изменять настройки автоматического подтверждения',
		payoutsChangeUrgency: 'изменять срочность',

		landingsSnippetsList: 'просматривать коды аналитики',
		landingsSnippetsUpdate: 'обновлять коды аналитики',
		landingsSnippetsDelete: 'удалять коды аналитики',

		campaignDomainsList: 'просматривать домены парковки',
		campaignDomainsCreate: 'обновлять домены парковки',
		campaignDomainsDelete: 'удалять домены парковки',

		threadsList: 'просматривать тикеты',
		threadsCreate: 'создавать тикеты',
		threadsAnswer: 'отвечать на тикеты',
		threadsClose: 'закрывать тикеты',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'просматривать офферы',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'создавать офферы',
		offersGrant: 'давать доступ к офферу',
		topOffersViewAll: 'топ офферы просматривать все',
		offersChangeCap: 'менять капу офера',

		viewMarketingReports: 'просматривать отчеты маркетинга',

		newsList: 'просматривать новости',
		newsCreate: 'создавать новости',
		newsDelete: 'удалять новости',

		discountsList: 'просматривать скидки',
		discountsCreate: 'создавать скидки',
		discountsDelete: 'удалять скидки',

		managersAffiliatesActivity: 'просматривать активность менеджеров/вебов',
		affiliatesActivityList: 'просматривать активность партнеров',
		registrationAnalytics: 'просматривать аналитику регистраций',
		alertsAnalytics: 'просматривать аналитику алертов',
		marketingFunnel: 'просматривать маркетинговый отчет',
		productCap: 'работать с продуктовой капой',
		priorities: 'работать с приоритетами',
		weeklyReport: 'просматривать еженедельный отчет',
		quidsReport: 'просматривать отчет по квидам',

		mailingsList: 'просматривать рассылки',
		mailingsCreate: 'создавать рассылки',
		mailingsDelete: 'удалять рассылки',

		definedReferersList: 'просматривать определенные рефереры',
		definedReferersUpdate: 'обновлять определенные рефереры',

		extThreadsList: 'просматривать внешние тикеты',
		extThreadsAnswer: 'отвечать на внешние тикеты',
		extThreadsClose: 'закрывать внешние тикеты',

		campaignsList: 'просматривать потоки',

		pollsList: 'просматривать опросы',
		pollsCreate: 'создавать опросы',
		pollsDelete: 'удалять опросы',

		wm: 'работать с WM',

		advRequestList: 'просматривать запросы рекламодателей',

		affiliatesRedeemList: 'просматривать выкуп',

		conversionsManualApprove: 'подтверждать конверсии вручную',
		conversionsPastManualApprove: 'подтверждать отмены и треш конверсии вручную',
		conversionsApproveDaily: 'Auto approve daily',
		guarantRegisterView: 'Guarant register view',
		garantForecastView: 'Guarant forecast view',
		guarantRegisterConfirmProlong: 'Guarant register confirm prolong',
		garantApproveRequestsView: 'Garant approve requests view',
		garantApproveRequestsApprove: 'Garant approve requests approve',

		manualApproveRequests: 'Manual approve requests',
		manualApproveRequestsConfirm: 'Manual approve requests confirm',

		landingNewsList: 'просматривать новости лендинга',
		landingNewsCreate: 'редактировать новости лендинга ',

		finReportsView: 'просматривать финансовые отчеты',
		landingReportsView: 'просматривать landing отчеты',
		manualAdjustmentsView: 'просматривать ручные корректировки',

		affiliateReportsView: 'просматривать отчеты по пользователям',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'просматривать лог выплат',

		sessionsDelete: 'удалять сессии',

		exchangeRatesList: 'просматривать курсы валют',
		exchangeRatesUpdate: 'обновлять курсы валют',

		ranksPointsReport: 'просматривать отчет по ранкам и квидам',

		banners: 'работать с баннерами',

		popups: 'работать с попапами',

		cplRulesList: 'просматривать CPL правила',
		cplRulesEdit: 'редактировать CPL правила',

		approvedRejectPayoutsList: 'просматривать Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'редактировать Approved Rejected Payouts',

		geoPayoutRatesList: 'просматривать Geo Payout Rates',
		geoPayoutRatesEdit: 'редактировать Geo Payout Rates',

		totalDebtView: 'просматривать Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'просматривать продуктивность всех менеджеров',
		affiliateManagersProductivityShowMe: 'просматривать продуктивность себя',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		createTasks: 'affiliate_crm_create_tasks'
	},
	uk: {
		adminsList: 'просматривать админов',
		adminsCreate: 'создавать админа',
		adminsDelete: 'удалять админа',
		adminsSetGlobalPermissions: 'устанавливать глобальные права',

		analyticsView: 'просматривать аналитику',
		analyticsViewExtendedStat: 'просматривать расширеную аналитику',
		changeConversionStatuses: 'изменять статусы лидов',
		analyticsViewConversionsProfit: 'просматривать маржу по конверсиям',

		autotrashView: 'просматривать автотреш',
		autotrashResend: 'переотправлять автотреш',

		bmAccountsView: 'просматривать БМ аккаунты',
		bmAccountsUpdate: 'апдейтить БМ аккаунты',

		contestView: 'Просматривать конкурсы',
		contestEdit: 'Редактировать конкурсы',

		affiliatesList: 'просматривать партнеров',
		affiliatesListDownload: 'скачивать список партнеров',
		affiliateIdsList: 'просматривать id вебов',
		affiliatesUpdate: 'обновлять партнера',
		affiliatesUpdateFeatureFlags: 'обновлять feature_flags',
		loginWithAffiliate: 'заходить под партнером',
		transferPoints: 'начислять поинты',
		addLeadSource: 'добавлять источник лидов',
		topAffiliatesViewAll: 'просмотре всех топ вебов',
		topCountriesViewAll: 'просмотр всех стран',
		topCountriesViewAllProfits: 'просмотр всех профитов',
		canCopyTotalRow: 'можно копировать тотал строку',

		transferMoneyBetweenAffiliates: 'перевод дененг между вебами',
		currencyExchange: 'обмен валют у веба',
		transferPrizeMoney: 'начисления за подарки',
		transferHiddenMoney: 'начисления списаных денег',
		transferAdjustmentMoney: 'ручные корректировки начислений',

		transferBalanceAndAccumulatedPoints: 'перенос баланса и накопленных поинтов',

		goodsView: 'просматривать товары',
		goodsCreate: 'создавать товары',
		goodsUpdate: 'обновлять товары',
		goodsDelete: 'удалять товары',

		achievementsView: 'achievements view',
		achievementsUpdate: 'achievements update',
		missionsView: 'missions view',
		missionsUpdate: 'missions update',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		chainsView: 'просматривать связки',
		chainsCreate: 'создавать связки',
		chainsUpdate: 'редактировать связки',

		payoutSystemsList: 'просматривать системы выплат',
		payoutSystemsCreate: 'создавать системы выплат',
		payoutSystemsUpdate: 'обновлять системы выплат',
		payoutSystemsDelete: 'удалять системы выплат',
		payoutSystemsGetBalance: 'смотреть балансы систем выплат',

		transactionsCreate: 'переводить средства партнерам на баланс',

		payoutsList: 'просматривать выплаты',
		payoutsApprove: 'подтверждать выплаты',
		payoutsConfirm: 'оплачивать выплаты',
		payoutsCreate: 'создавать выплаты партнерам',
		payoutsChangeAutoConfirmSettings: 'изменять настройки автоматического подтверждения',

		landingsSnippetsList: 'просматривать коды аналитики',
		landingsSnippetsUpdate: 'обновлять коды аналитики',
		landingsSnippetsDelete: 'удалять коды аналитики',

		campaignDomainsList: 'просматривать домены парковки',
		campaignDomainsCreate: 'обновлять домены парковки',
		campaignDomainsDelete: 'удалять домены парковки',

		threadsList: 'просматривать тикеты',
		threadsCreate: 'создавать тикеты',
		threadsAnswer: 'отвечать на тикеты',
		threadsClose: 'закрывать тикеты',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'просматривать офферы',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'создавать офферы',
		offersGrant: 'давать доступ к офферу',
		topOffersViewAll: 'топ офферы просматривать все',
		offersChangeCap: 'менять капу офера',

		viewMarketingReports: 'просматривать отчеты маркетинга',

		newsList: 'просматривать новости',
		newsCreate: 'создавать новости',
		newsDelete: 'удалять новости',

		discountsList: 'просматривать скидки',
		discountsCreate: 'создавать скидки',
		discountsDelete: 'удалять скидки',

		managersAffiliatesActivity: 'просматривать активность менеджеров/вебов',
		affiliatesActivityList: 'просматривать активность партнеров',
		registrationAnalytics: 'просматривать аналитику регистраций',
		alertsAnalytics: 'просматривать аналитику алертов',
		marketingFunnel: 'просматривать маркетинговый отчет',
		productCap: 'работать с продуктовой капой',
		priorities: 'работать с приоритетами',
		weeklyReport: 'просматривать еженедельный отчет',
		quidsReport: 'просматривать отчет по квидам',

		mailingsList: 'просматривать рассылки',
		mailingsCreate: 'создавать рассылки',
		mailingsDelete: 'удалять рассылки',

		definedReferersList: 'просматривать определенные рефереры',
		definedReferersUpdate: 'обновлять определенные рефереры',

		extThreadsList: 'просматривать внешние тикеты',
		extThreadsAnswer: 'отвечать на внешние тикеты',
		extThreadsClose: 'закрывать внешние тикеты',

		campaignsList: 'просматривать потоки',

		pollsList: 'просматривать опросы',
		pollsCreate: 'создавать опросы',
		pollsDelete: 'удалять опросы',

		wm: 'работать с WM',

		advRequestList: 'просматривать запросы рекламодателей',

		affiliatesRedeemList: 'просматривать выкуп',

		conversionsManualApprove: 'подтверждать конверсии вручную',
		conversionsPastManualApprove: 'подтверждать отмены и треш конверсии вручную',
		conversionsApproveDaily: 'Auto approve daily',
		guarantRegisterView: 'Guarant register view',
		garantForecastView: 'Guarant forecast view',
		guarantRegisterConfirmProlong: 'Guarant register confirm prolong',
		garantApproveRequestsView: 'Garant approve requests view',
		garantApproveRequestsApprove: 'Garant approve requests approve',

		manualApproveRequests: 'Manual approve requests',
		manualApproveRequestsConfirm: 'Manual approve requests confirm',

		landingNewsList: 'просматривать новости лендинга',
		landingNewsCreate: 'редактировать новости лендинга ',

		finReportsView: 'просматривать финансовые отчеты',
		landingReportsView: 'просматривать landing отчеты',
		manualAdjustmentsView: 'просматривать ручные корректировки',

		affiliateReportsView: 'просматривать отчеты по пользователям',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'просматривать лог выплат',

		sessionsDelete: 'удалять сессии',

		exchangeRatesList: 'просматривать курсы валют',
		exchangeRatesUpdate: 'обновлять курсы валют',

		ranksPointsReport: 'просматривать отчет по ранкам и квидам',

		banners: 'работать с баннерами',

		popups: 'работать с попапами',

		cplRulesList: 'просматривать CPL правила',
		cplRulesEdit: 'редактировать CPL правила',

		approvedRejectPayoutsList: 'просматривать Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'редактировать Approved Rejected Payouts',

		geoPayoutRatesList: 'просматривать Geo Payout Rates',
		geoPayoutRatesEdit: 'редактировать Geo Payout Rates',

		totalDebtView: 'просматривать Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'просматривать продуктивность всех менеджеров',
		affiliateManagersProductivityShowMe: 'просматривать продуктивность себя',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
	},
	en: {
		adminsList: 'view admins',
		adminsCreate: 'create admin',
		adminsDelete: 'delete admin',
		adminsSetGlobalPermissions: 'set global admin permissions',

		analyticsView: 'view analytics',
		analyticsViewExtendedStat: 'view extended analytics',
		changeConversionStatuses: 'change сonversion statuses',
		analyticsViewConversionsProfit: 'view conversions profit',

		autotrashView: 'view autotrash',
		autotrashResend: 'resend autotrash',

		bmAccountsView: 'bm accounts view',
		bmAccountsUpdate: 'bm accounts update',

		contestView: 'contest view',
		contestEdit: 'contest edit',

		affiliatesList: 'view affiliates',
		affiliatesListDownload: 'download affiliates list',
		affiliateIdsList: 'view affiliate ids',
		affiliatesUpdate: 'update affiliate',
		affiliatesUpdateFeatureFlags: 'update feature_flags',
		loginWithAffiliate: 'login with affiliate',
		transferPoints: 'transfer points',
		addLeadSource: 'add lead source',
		topAffiliatesViewAll: 'top affiliates view all',
		topCountriesViewAll: 'top affiliates view all',
		topCountriesViewAllProfits: 'top affiliates view profits',
		canCopyTotalRow: 'can copy total row',

		transferMoneyBetweenAffiliates: 'transfer money between affiliates',
		currencyExchange: 'exchange affiliate money',
		transferPrizeMoney: 'transfer prize money',
		transferHiddenMoney: 'transfer hidden money',
		transferAdjustmentMoney: 'transfer adjustment money',

		transferBalanceAndAccumulatedPoints: 'transfer balance and accumulated points',

		chainsView: 'chains view',
		chainsCreate: 'chains create',
		chainsUpdate: 'chains update',

		goodsView: 'goods_view',
		goodsCreate: 'goods_create',
		goodsUpdate: 'goods_update',
		goodsDelete: 'goods_delete',

		achievementsView: 'achievements view',
		achievementsUpdate: 'achievements update',
		missionsView: 'missions view',
		missionsUpdate: 'missions update',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		payoutSystemsList: 'view payout systems',
		payoutSystemsCreate: 'create payout system',
		payoutSystemsUpdate: 'update payout system',
		payoutSystemsDelete: 'delete payout system',
		payoutSystemsGetBalance: 'view payout system balances',

		viewMarketingReports: 'view marketing reports',

		transactionsCreate: 'create affiliate balances transaction',

		payoutsList: 'view payouts',
		payoutsApprove: 'approve payouts',
		payoutsConfirm: 'confirm payouts',
		payoutsCreate: 'create payouts',
		payoutsChangeAutoConfirmSettings: 'change auto confirm settings',
		payoutsChangeUrgency: 'change urgency',

		landingsSnippetsList: 'view analytics codes',
		landingsSnippetsUpdate: 'update analytics codes',
		landingsSnippetsDelete: 'delete analytics codes',

		campaignDomainsList: 'view campaign parking domains',
		campaignDomainsCreate: 'update campaign parking domains',
		campaignDomainsDelete: 'delete campaign parking domains',

		threadsList: 'view tickets',
		threadsCreate: 'create threads',
		threadsAnswer: 'answer on threads',
		threadsClose: 'close threads',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'view offers',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'create offers',
		offersGrant: 'grant access to offer',
		topOffersViewAll: 'view all top offers',
		offersChangeCap: 'offers change cap',

		newsList: 'view news',
		newsCreate: 'create news',
		newsDelete: 'delete news',

		discountsList: 'view discounts',
		discountsCreate: 'create discounts',
		discountsDelete: 'delete discounts',

		managersAffiliatesActivity: 'view managers/affiliates activity',
		affiliatesActivityList: 'view affiliates activity',
		registrationAnalytics: 'view registration analytics',
		alertsAnalytics: 'view alerts analytics',
		marketingFunnel: 'view marketing funnel',
		productCap: 'work with product cap',
		priorities: 'work with priorities',
		weeklyReport: 'view weekly report',
		quidsReport: 'view quids report',

		mailingsList: 'view mailings',
		mailingsCreate: 'create mailings',
		mailingsDelete: 'delete mailings',

		extThreadsList: 'view external threads',
		extThreadsAnswer: 'answer on external threads',
		extThreadsClose: 'close external threads',

		definedReferersList: 'view defined referers',
		definedReferersUpdate: 'update defined referers',

		campaignsList: 'view campaigns',

		pollsList: 'view polls',
		pollsCreate: 'create polls',
		pollsDelete: 'delete polls',

		wm: 'work with WM',

		advRequestList: 'view advertisers requests',

		affiliatesRedeemList: 'view affiliates redeem',

		conversionsManualApprove: 'approve conversions manually',
		conversionsPastManualApprove: 'approve past conversions manually',
		conversionsApproveDaily: 'Auto approve daily',
		guarantRegisterView: 'Guarant register view',
		garantForecastView: 'Guarant forecast view',
		guarantRegisterConfirmProlong: 'Guarant register confirm prolong',
		garantApproveRequestsView: 'Garant approve requests view',
		garantApproveRequestsApprove: 'Garant approve requests approve',

		manualApproveRequests: 'Manual approve requests',
		manualApproveRequestsConfirm: 'Manual approve requests confirm',

		landingNewsList: 'view landing news',
		landingNewsCreate: 'edit landing news',

		finReportsView: 'view financial reports',
		landingReportsView: 'view landing reports',
		manualAdjustmentsView: 'view manual adjustments',

		affiliateReportsView: 'view affiliate reports',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'view payout log',

		sessionsDelete: 'delete session',

		exchangeRatesList: 'view exchange rates',
		exchangeRatesUpdate: 'update exchange rates',

		ranksPointsReport: 'view ranks and points report',

		banners: 'work with banners',

		popups: 'work with popups',

		cplRulesList: 'view CPL rules',
		cplRulesEdit: 'edit CPL rules',

		approvedRejectPayoutsList: 'view Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'edit Approved Rejected Payouts',

		geoPayoutRatesList: 'view Geo Payout Rates',
		geoPayoutRatesEdit: 'edit Geo Payout Rates',

		totalDebtView: 'view Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'see productivity of all managers',
		affiliateManagersProductivityShowMe: 'see productivity of myself',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
	},
	de: {
		adminsList: 'view admins',
		adminsCreate: 'create admin',
		adminsDelete: 'delete admin',
		adminsSetGlobalPermissions: 'set global admin permissions',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		analyticsView: 'view analytics',
		analyticsViewExtendedStat: 'view extended analytics',
		changeConversionStatuses: 'change conversion statuses',
		analyticsViewConversionsProfit: 'view conversions profit',

		autotrashView: 'view autotrash',
		autotrashResend: 'resend autotrash',

		bmAccountsView: 'bm accounts view',
		bmAccountsUpdate: 'bm accounts update',

		contestView: 'contest view',
		contestEdit: 'contest edit',

		affiliatesList: 'view affiliates',
		affiliatesListDownload: 'download affiliates list',
		affiliateIdsList: 'view affiliate ids',
		affiliatesUpdate: 'update affiliate',
		affiliatesUpdateFeatureFlags: 'update feature_flags',
		loginWithAffiliate: 'login with affiliate',
		transferPoints: 'transfer points',
		addLeadSource: 'add lead source',
		topAffiliatesViewAll: 'top affiliates view all',
		topCountriesViewAll: 'top affiliates view all',
		topCountriesViewAllProfits: 'top affiliates view profits',
		canCopyTotalRow: 'can copy total row',

		transferMoneyBetweenAffiliates: 'transfer money between affiliates',
		currencyExchange: 'exchange affiliate money',
		transferPrizeMoney: 'transfer prize money',
		transferHiddenMoney: 'transfer hidden money',
		transferAdjustmentMoney: 'transfer adjustment money',

		transferBalanceAndAccumulatedPoints: 'transfer balance and accumulated points',

		chainsView: 'chains view',
		chainsCreate: 'chains create',
		chainsUpdate: 'chains update',

		viewMarketingReports: 'view marketing reports',

		payoutSystemsList: 'view payout systems',
		payoutSystemsCreate: 'create payout system',
		payoutSystemsUpdate: 'update payout system',
		payoutSystemsDelete: 'delete payout system',
		payoutSystemsGetBalance: 'view payout system balances',

		transactionsCreate: 'create affiliate balances transaction',

		payoutsList: 'view payouts',
		payoutsApprove: 'approve payouts',
		payoutsConfirm: 'confirm payouts',
		payoutsCreate: 'create payouts',
		payoutsChangeAutoConfirmSettings: 'change auto confirm settings',
		payoutsChangeUrgency: 'change urgency',

		landingsSnippetsList: 'view analytics codes',
		landingsSnippetsUpdate: 'update analytics codes',
		landingsSnippetsDelete: 'delete analytics codes',

		campaignDomainsList: 'view campaign parking domains',
		campaignDomainsCreate: 'update campaign parking domains',
		campaignDomainsDelete: 'delete campaign parking domains',

		threadsList: 'view tickets',
		threadsCreate: 'create threads',
		threadsAnswer: 'answer on threads',
		threadsClose: 'close threads',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'view offers',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'create offers',
		offersGrant: 'grant access to offer',
		topOffersViewAll: 'view all top offers',
		offersChangeCap: 'offers change cap',

		newsList: 'view news',
		newsCreate: 'create news',
		newsDelete: 'delete news',

		discountsList: 'view discounts',
		discountsCreate: 'create discounts',
		discountsDelete: 'delete discounts',

		managersAffiliatesActivity: 'view managers/affiliates activity',
		affiliatesActivityList: 'view affiliates activity',
		registrationAnalytics: 'view registration analytics',
		alertsAnalytics: 'view alerts analytics',
		marketingFunnel: 'view marketing funnel',
		productCap: 'work with product cap',
		priorities: 'work with priorities',
		weeklyReport: 'view weekly report',
		quidsReport: 'view quids report',

		mailingsList: 'view mailings',
		mailingsCreate: 'create mailings',
		mailingsDelete: 'delete mailings',

		definedReferersList: 'view defined referers',
		definedReferersUpdate: 'update defined referers',

		extThreadsList: 'view external threads',
		extThreadsAnswer: 'answer on external threads',
		extThreadsClose: 'close external threads',

		campaignsList: 'view campaigns',

		pollsList: 'view polls',
		pollsCreate: 'create polls',
		pollsDelete: 'delete polls',

		wm: 'work with WM',

		advRequestList: 'view advertisers requests',

		affiliatesRedeemList: 'view affiliates redeem',

		landingNewsList: 'view landing news',
		landingNewsCreate: 'edit landing news',

		finReportsView: 'view financial reports',
		landingReportsView: 'view landing reports',
		manualAdjustmentsView: 'view manual adjustments',

		affiliateReportsView: 'view affiliate reports',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'view payout log',

		sessionsDelete: 'delete session',

		exchangeRatesList: 'view exchange rates',
		exchangeRatesUpdate: 'update exchange rates',

		ranksPointsReport: 'view ranks and points report',

		banners: 'work with banners',

		popups: 'work with popups',

		cplRulesList: 'view CPL rules',
		cplRulesEdit: 'edit CPL rules',

		approvedRejectPayoutsList: 'view Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'edit Approved Rejected Payouts',

		geoPayoutRatesList: 'view Geo Payout Rates',
		geoPayoutRatesEdit: 'edit Geo Payout Rates',

		totalDebtView: 'view Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'see productivity of all managers',
		affiliateManagersProductivityShowMe: 'see productivity of myself',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
	},
	vi: {
		adminsList: 'view admins',
		adminsCreate: 'create admin',
		adminsDelete: 'delete admin',
		adminsSetGlobalPermissions: 'set global admin permissions',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		analyticsView: 'view analytics',
		analyticsViewExtendedStat: 'view extended analytics',
		changeConversionStatuses: 'change conversion statuses',
		analyticsViewConversionsProfit: 'view conversions profit',

		autotrashView: 'view autotrash',
		autotrashResend: 'resend autotrash',

		affiliatesList: 'view affiliates',
		affiliatesListDownload: 'download affiliates list',
		affiliateIdsList: 'view affiliate ids',
		affiliatesUpdate: 'update affiliate',
		affiliatesUpdateFeatureFlags: 'update feature_flags',
		loginWithAffiliate: 'login with affiliate',
		transferPoints: 'transfer points',
		addLeadSource: 'add lead source',
		topAffiliatesViewAll: 'top affiliates view all',
		topCountriesViewAll: 'top affiliates view all',
		topCountriesViewAllProfits: 'top affiliates view profits',
		canCopyTotalRow: 'can copy total row',

		transferMoneyBetweenAffiliates: 'transfer money between affiliates',
		currencyExchange: 'exchange affiliate money',
		transferPrizeMoney: 'transfer prize money',
		transferHiddenMoney: 'transfer hidden money',
		transferAdjustmentMoney: 'transfer adjustment money',

		transferBalanceAndAccumulatedPoints: 'transfer balance and accumulated points',

		viewMarketingReports: 'view marketing reports',

		chainsView: 'chains view',
		chainsCreate: 'chains create',
		chainsUpdate: 'chains update',

		bmAccountsView: 'bm accounts view',
		bmAccountsUpdate: 'bm accounts update',

		contestView: 'contest view',
		contestEdit: 'contest edit',

		payoutSystemsList: 'view payout systems',
		payoutSystemsCreate: 'create payout system',
		payoutSystemsUpdate: 'update payout system',
		payoutSystemsDelete: 'delete payout system',
		payoutSystemsGetBalance: 'view payout system balances',

		transactionsCreate: 'create affiliate balances transaction',

		payoutsList: 'view payouts',
		payoutsApprove: 'approve payouts',
		payoutsConfirm: 'confirm payouts',
		payoutsCreate: 'create payouts',
		payoutsChangeAutoConfirmSettings: 'change auto confirm settings',
		payoutsChangeUrgency: 'change urgency',

		landingsSnippetsList: 'view analytics codes',
		landingsSnippetsUpdate: 'update analytics codes',
		landingsSnippetsDelete: 'delete analytics codes',

		campaignDomainsList: 'view campaign parking domains',
		campaignDomainsCreate: 'update campaign parking domains',
		campaignDomainsDelete: 'delete campaign parking domains',

		threadsList: 'view tickets',
		threadsCreate: 'create threads',
		threadsAnswer: 'answer on threads',
		threadsClose: 'close threads',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'view offers',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'create offers',
		offersGrant: 'grant access to offer',
		topOffersViewAll: 'view all top offers',
		offersChangeCap: 'offers change cap',

		newsList: 'view news',
		newsCreate: 'create news',
		newsDelete: 'delete news',

		discountsList: 'view discounts',
		discountsCreate: 'create discounts',
		discountsDelete: 'delete discounts',

		managersAffiliatesActivity: 'view managers/affiliates activity',
		affiliatesActivityList: 'view affiliates activity',
		registrationAnalytics: 'view registration analytics',
		alertsAnalytics: 'view alerts analytics',
		marketingFunnel: 'view marketing funnel',
		productCap: 'work with product cap',
		priorities: 'work with priorities',
		weeklyReport: 'view weekly report',
		quidsReport: 'view quids report',

		mailingsList: 'view mailings',
		mailingsCreate: 'create mailings',
		mailingsDelete: 'delete mailings',

		extThreadsList: 'view external threads',
		extThreadsAnswer: 'answer on external threads',
		extThreadsClose: 'close external threads',

		definedReferersList: 'view defined referers',
		definedReferersUpdate: 'update defined referers',

		campaignsList: 'view campaigns',

		pollsList: 'view polls',
		pollsCreate: 'create polls',
		pollsDelete: 'delete polls',

		wm: 'work with WM',

		advRequestList: 'view advertisers requests',

		affiliatesRedeemList: 'view affiliates redeem',

		conversionsManualApprove: 'approve conversions manually',
		conversionsPastManualApprove: 'approve past conversions manually',
		conversionsApproveDaily: 'Auto approve daily',
		guarantRegisterView: 'Guarant register view',
		garantForecastView: 'Guarant forecast view',
		guarantRegisterConfirmProlong: 'Guarant register confirm prolong',
		garantApproveRequestsView: 'Garant approve requests view',
		garantApproveRequestsApprove: 'Garant approve requests approve',

		manualApproveRequests: 'Manual approve requests',
		manualApproveRequestsConfirm: 'Manual approve requests confirm',

		landingNewsList: 'view landing news',
		landingNewsCreate: 'edit landing news',

		finReportsView: 'view financial reports',
		landingReportsView: 'view landing reports',
		manualAdjustmentsView: 'view manual adjustments',

		affiliateReportsView: 'view affiliate reports',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'view payout log',

		sessionsDelete: 'delete session',

		exchangeRatesList: 'view exchange rates',
		exchangeRatesUpdate: 'update exchange rates',

		ranksPointsReport: 'view ranks and points report',

		banners: 'work with banners',

		popups: 'work with popups',

		cplRulesList: 'view CPL rules',
		cplRulesEdit: 'edit CPL rules',

		approvedRejectPayoutsList: 'view Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'edit Approved Rejected Payouts',

		geoPayoutRatesList: 'view Geo Payout Rates',
		geoPayoutRatesEdit: 'edit Geo Payout Rates',

		totalDebtView: 'view Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'see productivity of all managers',
		affiliateManagersProductivityShowMe: 'see productivity of myself',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
	},
	th: {
		adminsList: 'view admins',
		adminsCreate: 'create admin',
		adminsDelete: 'delete admin',
		adminsSetGlobalPermissions: 'set global admin permissions',

		payoutRequestsViewPersonal: 'payout requests personal view',
		payoutRequestsViewAll: 'payout requests view all',
		payoutRequestsViewMatrixAndHistory: 'payout requests matrix and history',
		payoutRequestsReview: 'payout requests review',
		payoutRequestsManagerRole: 'payout requests manager role',
		payoutRequestsConfirm: 'payout requests confirm',

		analyticsView: 'view analytics',
		analyticsViewExtendedStat: 'view extended analytics',
		changeConversionStatuses: 'change conversion statuses',
		analyticsViewConversionsProfit: 'view conversions profit',

		autotrashView: 'view autotrash',
		autotrashResend: 'resend autotrash',

		affiliatesList: 'view affiliates',
		affiliatesListDownload: 'download affiliates list',
		affiliateIdsList: 'view affiliate ids',
		affiliatesUpdate: 'update affiliate',
		affiliatesUpdateFeatureFlags: 'update feature_flags',
		loginWithAffiliate: 'login with affiliate',
		transferPoints: 'transfer points',
		addLeadSource: 'add lead source',
		topAffiliatesViewAll: 'top affiliates view all',
		topCountriesViewAll: 'top affiliates view all',
		topCountriesViewAllProfits: 'top affiliates view profits',
		canCopyTotalRow: 'can copy total row',

		transferMoneyBetweenAffiliates: 'transfer money between affiliates',
		currencyExchange: 'exchange affiliate money',
		transferPrizeMoney: 'transfer prize money',
		transferHiddenMoney: 'transfer hidden money',
		transferAdjustmentMoney: 'transfer adjustment money',

		transferBalanceAndAccumulatedPoints: 'transfer balance and accumulated points',

		bmAccountsView: 'bm accounts view',
		bmAccountsUpdate: 'bm accounts update',

		contestView: 'contest view',
		contestEdit: 'contest edit',

		chainsView: 'chains view',
		chainsCreate: 'chains create',
		chainsUpdate: 'chains update',

		viewMarketingReports: 'view marketing reports',

		payoutSystemsList: 'view payout systems',
		payoutSystemsCreate: 'create payout system',
		payoutSystemsUpdate: 'update payout system',
		payoutSystemsDelete: 'delete payout system',
		payoutSystemsGetBalance: 'view payout system balances',

		transactionsCreate: 'create affiliate balances transaction',

		payoutsList: 'view payouts',
		payoutsApprove: 'approve payouts',
		payoutsConfirm: 'confirm payouts',
		payoutsCreate: 'create payouts',
		payoutsChangeAutoConfirmSettings: 'change auto confirm settings',
		payoutsChangeUrgency: 'change urgency',

		landingsSnippetsList: 'view analytics codes',
		landingsSnippetsUpdate: 'update analytics codes',
		landingsSnippetsDelete: 'delete analytics codes',

		campaignDomainsList: 'view campaign parking domains',
		campaignDomainsCreate: 'update campaign parking domains',
		campaignDomainsDelete: 'delete campaign parking domains',

		threadsList: 'view tickets',
		threadsCreate: 'create threads',
		threadsAnswer: 'answer on threads',
		threadsClose: 'close threads',
		threadsListExcludePersonal: 'threads_list_exclude_personal',
		threadsListOnlyPersonal: 'threads_list_only_personal',

		offersList: 'view offers',
		offersListRemoved: 'offers list removed',
		offersListExport: 'offers_list_export',
		offersCreate: 'create offers',
		offersGrant: 'grant access to offer',
		topOffersViewAll: 'view all top offers',
		offersChangeCap: 'offers change cap',

		newsList: 'view news',
		newsCreate: 'create news',
		newsDelete: 'delete news',

		discountsList: 'view discounts',
		discountsCreate: 'create discounts',
		discountsDelete: 'delete discounts',

		managersAffiliatesActivity: 'view managers/affiliates activity',
		affiliatesActivityList: 'view affiliates activity',
		registrationAnalytics: 'view registration analytics',
		alertsAnalytics: 'view alerts analytics',
		marketingFunnel: 'view marketing funnel',
		productCap: 'work with product cap',
		priorities: 'work with priorities',
		weeklyReport: 'view weekly report',
		quidsReport: 'view quids report',

		mailingsList: 'view mailings',
		mailingsCreate: 'create mailings',
		mailingsDelete: 'delete mailings',

		extThreadsList: 'view external threads',
		extThreadsAnswer: 'answer on external threads',
		extThreadsClose: 'close external threads',

		definedReferersList: 'view defined referers',
		definedReferersUpdate: 'update defined referers',

		campaignsList: 'view campaigns',

		pollsList: 'view polls',
		pollsCreate: 'create polls',
		pollsDelete: 'delete polls',

		wm: 'work with WM',

		advRequestList: 'view advertisers requests',

		affiliatesRedeemList: 'view affiliates redeem',

		conversionsManualApprove: 'approve conversions manually',
		conversionsPastManualApprove: 'approve past conversions manually',

		landingNewsList: 'view landing news',
		landingNewsCreate: 'edit landing news',

		finReportsView: 'view financial reports',
		landingReportsView: 'view landing reports',
		manualAdjustmentsView: 'view manual adjustments',

		affiliateReportsView: 'view affiliate reports',
		affiliateMonthlyReportView: 'affiliate monthly report view',

		payoutLogView: 'view payout log',

		sessionsDelete: 'delete session',

		exchangeRatesList: 'view exchange rates',
		exchangeRatesUpdate: 'update exchange rates',

		ranksPointsReport: 'view ranks and points report',

		banners: 'work with banners',

		popups: 'work with popups',

		cplRulesList: 'view CPL rules',
		cplRulesEdit: 'edit CPL rules',

		approvedRejectPayoutsList: 'view Approved Rejected Payouts',
		approvedRejectPayoutsEdit: 'edit Approved Rejected Payouts',

		geoPayoutRatesList: 'view Geo Payout Rates',
		geoPayoutRatesEdit: 'edit Geo Payout Rates',

		totalDebtView: 'view Total Debt',

		trafficAccountingView: 'traffic_accounting_view',
		affiliateManagersProductivityListAll: 'see productivity of all managers',
		affiliateManagersProductivityShowMe: 'see productivity of myself',

		affiliateCrmEditConfig: 'affiliate_crm_edit_config',
		affiliateCrmEditConfigViewAllPages: 'affiliate_crm_view_all_pages',
		affiliateCrmCreateTasks: 'affiliate_crm_create_tasks'
	}
};

module.exports = {
	enum: permissions,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/admin-permissions.js